/**
 * Asset selector - usage module
 *
 * This module deals with creating and handling usage types.
 *
 * @author Rohit Biswas (rbiswas@yext.com)
 */
goog.module('yext.dam.assetselector.usage');

/**
 * Creates a UsageType JSON string for specific profile fields
 *
 * @param {!Array<string>|string} fieldIds Either a single field id or a list of field Ids (as strings)
 */
const forProfileFields = function(fieldIds) {
  if (typeof fieldIds === 'undefined' || fieldIds === null || fieldIds.length == 0) {
    throw new Error('Field Ids cannot be empty');
  } else if (typeof fieldIds === 'string') {
    fieldIds = [fieldIds];
  }

  return JSON.stringify({
    type: 'PROFILE_FIELDS',
    fields: [...fieldIds],
  });
};

/**
 * Creates a UsageType JSON string for review response usages
 */
const forReviewResponse = function() {
  return JSON.stringify({
    type: 'REVIEW_RESPONSE',
  });
};

/**
 * Creates a UsageType JSON string for review response usages
 * @suppress {unusedLocalVariables}
 */
const forReviewGreeting = function() {
  return JSON.stringify({
    type: 'REVIEW_GREETING',
  });
};

/**
 * Creates a UsageType JSON string for review response usages
 * @suppress {unusedLocalVariables}
 */
const forReviewValueStatement = function() {
  return JSON.stringify({
    type: 'REVIEW_VALUE_STATEMENT',
  });
};

/**
 * Creates a UsageType JSON string for review response usages
 * @suppress {unusedLocalVariables}
 */
const forReviewPositiveSentiment = function() {
  return JSON.stringify({
    type: 'REVIEW_POSITIVE_SENTIMENT',
  });
};

/**
 * Creates a UsageType JSON string for review response usages
 * @suppress {unusedLocalVariables}
 */
const forReviewNegativeSentiment = function() {
  return JSON.stringify({
    type: 'REVIEW_NEGATIVE_SENTIMENT',
  });
};

/**
 * Creates a UsageType JSON string for review response usages
 * @suppress {unusedLocalVariables}
 */
const forReviewClosing = function() {
  return JSON.stringify({
    type: 'REVIEW_CLOSING',
  });
};

/**
 * Creates a UsageType JSON string for social posting usages
 */
const forSocialPosting = function() {
  return JSON.stringify({
    type: 'SOCIAL_POSTING',
  });
};

exports = {
  forProfileFields,
  forReviewResponse,
  forSocialPosting,
};
